(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const initAnnouncementBar = () => {
      const bar = document.querySelector('.announcement-bar');
      if (!bar || bar.dataset.announcementReady === 'true') return;

      const track = bar.querySelector('[data-announce-track]');
      const slides = Array.from(track?.querySelectorAll('.announcement-bar__msg') || []);
      const dots = Array.from(bar.querySelectorAll('[data-announce-dot]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (slides.length < 2) return;

      bar.dataset.announcementReady = 'true';

      let current = 0;
      let running = false;
      const pause = 4000;
      const speed = reduceMotion ? 0 : 500;

      const setDot = (index) => {
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      const resetSlide = (slide, visible) => {
        slide.style.transition = 'none';
        slide.style.transform = visible ? 'translateY(0)' : 'translateY(120%)';
        slide.style.opacity = visible ? '1' : '0';
        slide.toggleAttribute('aria-hidden', !visible);
      };

      slides.forEach((slide, index) => resetSlide(slide, index === 0));
      setDot(0);

      const advance = () => {
        if (running) return;

        running = true;
        const nextIndex = (current + 1) % slides.length;
        const outSlide = slides[current];
        const inSlide = slides[nextIndex];

        resetSlide(inSlide, false);
        inSlide.removeAttribute('aria-hidden');

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            outSlide.style.transition = `transform ${speed}ms cubic-bezier(0.33, 1, 0.68, 1), opacity ${speed}ms ease`;
            inSlide.style.transition = `transform ${speed}ms cubic-bezier(0.33, 1, 0.68, 1), opacity ${speed}ms ease`;
            outSlide.style.transform = 'translateY(-120%)';
            outSlide.style.opacity = '0';
            inSlide.style.transform = 'translateY(0)';
            inSlide.style.opacity = '1';
            setDot(nextIndex);

            window.setTimeout(() => {
              resetSlide(outSlide, false);
              current = nextIndex;
              running = false;
            }, speed);
          });
        });
      };

      window.setInterval(advance, pause + speed);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnouncementBar, { once: true });
    } else {
      initAnnouncementBar();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const cartForm   = document.getElementById('CartForm');
    const shipBar    = document.querySelector('[data-ship-bar]');
    const shipFill   = document.querySelector('[data-ship-fill]');
    const shipText   = document.querySelector('[data-ship-text]');
    const subtotalEl = document.querySelector('[data-cart-subtotal]');

    const threshold     = shipBar ? parseInt(shipBar.dataset.threshold || '0', 10) : 0;
    const thresholdMoney = shipBar ? shipBar.dataset.thresholdMoney || '' : '';

    // ── Helpers ──────────────────────────────────────────────
    const moneyFormat = (cents) => {
      const pounds = (cents / 100).toFixed(2);
      return '\u00a3' + (pounds.endsWith('.00') ? (cents / 100).toFixed(0) : pounds);
    };

    const updateShipBar = (totalCents) => {
      if (!shipBar || threshold <= 0) return;
      const qualifies = totalCents >= threshold;
      const pct = qualifies ? 100 : Math.round((totalCents / threshold) * 100);
      if (shipFill) shipFill.style.width = pct + '%';
      if (shipText) {
        if (qualifies) {
          shipText.innerHTML = '<span class="cart-section__ship-done">\uD83C\uDF89 You\u2019ve unlocked free UK delivery!</span>';
        } else {
          const remaining = moneyFormat(threshold - totalCents);
          shipText.innerHTML = 'Spend <strong>' + remaining + '</strong> more for free UK delivery';
        }
      }
    };

    const updateSubtotal = (totalCents) => {
      if (subtotalEl) subtotalEl.textContent = moneyFormat(totalCents);
    };

    // ── AJAX cart change ──────────────────────────────────────
    const cartChange = async (key, quantity) => {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      return res.json();
    };

    // ── Qty buttons ───────────────────────────────────────────
    document.querySelectorAll('[data-qty-dir]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key   = btn.dataset.qtyKey;
        const input = document.querySelector('[data-qty-input="' + key + '"]');
        if (!input) return;
        const dir     = parseInt(btn.dataset.qtyDir, 10);
        const current = parseInt(input.value, 10) || 0;
        const next    = Math.max(0, current + dir);
        input.value   = String(next);

        try {
          const cart = await cartChange(key, next);
          if (next === 0) {
            const row = document.querySelector('[data-cart-row="' + key + '"]');
            if (row) row.remove();
          }
          // Update line price
          const lineItem = (cart.items || []).find((i) => i.key === key);
          const linePriceEl = document.querySelector('[data-line-price="' + key + '"]');
          if (linePriceEl && lineItem) linePriceEl.textContent = moneyFormat(lineItem.line_price);

          updateSubtotal(cart.total_price);
          updateShipBar(cart.total_price);

          // Update header badge count if present
          const badge = document.querySelector('[data-cart-count]');
          if (badge) badge.textContent = cart.item_count;
        } catch (e) {
          if (cartForm) cartForm.submit();
        }
      });
    });

    // ── Remove buttons ────────────────────────────────────────
    document.querySelectorAll('[data-remove-key]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.removeKey;
        const row = document.querySelector('[data-cart-row="' + key + '"]');
        if (row) {
          row.style.opacity = '0.4';
          row.style.pointerEvents = 'none';
        }
        try {
          const cart = await cartChange(key, 0);
          if (row) row.remove();
          updateSubtotal(cart.total_price);
          updateShipBar(cart.total_price);
          const badge = document.querySelector('[data-cart-count]');
          if (badge) badge.textContent = cart.item_count;
          if (cart.item_count === 0) location.reload();
        } catch (e) {
          if (cartForm) cartForm.submit();
        }
      });
    });

    // ── Discount code redirect ────────────────────────────────
    const discountBtn = document.querySelector('[data-apply-discount]');
    const discountInput = document.getElementById('CartDiscountCode');
    const discountMsg = document.querySelector('[data-discount-msg]');
    if (discountBtn && discountInput) {
      discountBtn.addEventListener('click', () => {
        const code = discountInput.value.trim();
        if (!code) return;
        window.location = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
      discountInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') discountBtn.click();
      });
    }

    // ── Init ship bar ─────────────────────────────────────────
    if (shipBar) {
      const initTotal = subtotalEl
        ? Math.round(parseFloat((subtotalEl.textContent || '0').replace(/[^0-9.]/g, '')) * 100)
        : 0;
      // Bar already rendered server-side; no re-init needed on load.
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wireShelf = (track) => {
      const section = track.closest('.shopify-section');
      if (!section) return;
      const prev = section.querySelector('[data-featured-products-prev]');
      const next = section.querySelector('[data-featured-products-next]');
      if (!prev || !next) return;

      const scrollAmount = () => Math.max(280, Math.floor(track.clientWidth * 0.72));
      prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    };

    document.querySelectorAll('[data-featured-products-track]').forEach(wireShelf);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.site-header');
    const pickers = Array.from(document.querySelectorAll('.site-header__category-picker'));
    const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
    const mobileDrawer = document.querySelector('[data-mobile-nav-drawer]');
    const mobileClose = document.querySelector('[data-mobile-nav-close]');
    // Hide the header while scrolling down, reveal it on any scroll up.
    let lastScrollY = window.scrollY;
    let scrollTicking = false;
    const REVEAL_ZONE = 180;  // always show the header near the top of the page
    const SCROLL_NOISE = 5;   // ignore trackpad/momentum jitter

    // Never hide while the user is actually using the header.
    const headerIsBusy = () => {
      if (document.body.classList.contains('mobile-nav-open')) return true;
      if (header.querySelector('.site-header__category-picker[open]')) return true;
      const active = document.activeElement;
      if (active && active !== document.body && header.contains(active)) return true;
      return false;
    };

    const syncHeaderState = () => {
      if (!header) return;
      const y = Math.max(window.scrollY, 0);
      header.classList.toggle('is-scrolled', y > 24);

      const delta = y - lastScrollY;
      if (y <= REVEAL_ZONE) {
        header.classList.remove('is-hidden');
      } else if (Math.abs(delta) > SCROLL_NOISE && !headerIsBusy()) {
        header.classList.toggle('is-hidden', delta > 0);
      }
      if (Math.abs(delta) > SCROLL_NOISE) lastScrollY = y;
    };

    const onHeaderScroll = () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(() => {
        syncHeaderState();
        scrollTicking = false;
      });
    };

    syncHeaderState();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });

    // Keep the space .site-main reserves (--site-main-offset) equal to where the
    // header really ends - the header gains rows at narrower widths and a desktop
    // scrollbar on the nav row adds height. Only applies while the header is out of
    // flow (absolute/fixed); skipped while a dropdown or the drawer is open so page
    // content never jumps.
    const mainContent = document.getElementById('MainContent');
    let headerRestTop = 37;
    let lastMainOffset = -1;
    let resizeTicking = false;
    const syncHeaderHeight = () => {
      if (!header || !mainContent) return;
      if (document.body.classList.contains('mobile-nav-open')) return;
      if (header.querySelector('.site-header__category-picker[open]')) return;
      const styles = window.getComputedStyle(header);
      if (styles.position !== 'absolute' && styles.position !== 'fixed') return;
      if (!header.classList.contains('is-scrolled')) headerRestTop = parseFloat(styles.top) || headerRestTop;
      const mainTop = mainContent.getBoundingClientRect().top + window.scrollY;
      const offset = Math.max(0, Math.round(headerRestTop + header.offsetHeight - mainTop));
      if (offset !== lastMainOffset) {
        lastMainOffset = offset;
        document.documentElement.style.setProperty('--site-main-offset', offset + 'px');
      }
    };

    syncHeaderHeight();
    window.addEventListener('resize', () => {
      if (resizeTicking) return;
      resizeTicking = true;
      window.requestAnimationFrame(() => {
        syncHeaderHeight();
        resizeTicking = false;
      });
    }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeaderHeight);

    // Keyboard users tabbing into the header should always see it.
    if (header) {
      header.addEventListener('focusin', () => header.classList.remove('is-hidden'));
    }

    const setMobileDrawer = (open) => {
      if (!mobileToggle || !mobileDrawer) return;
      mobileDrawer.hidden = !open;
      mobileDrawer.classList.toggle('is-open', open);
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('mobile-nav-open', open);
    };

    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener('click', () => {
        const next = mobileDrawer.hidden;
        setMobileDrawer(next);
      });

      mobileDrawer.addEventListener('click', (event) => {
        if (event.target === mobileDrawer) setMobileDrawer(false);
      });
    }

    if (mobileClose) {
      mobileClose.addEventListener('click', () => setMobileDrawer(false));
    }

    if (!pickers.length) return;

    document.addEventListener('click', (event) => {
      pickers.forEach((picker) => {
        if (!picker.contains(event.target)) {
          picker.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      pickers.forEach((picker) => picker.removeAttribute('open'));
      setMobileDrawer(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const body = document.querySelector('[data-hub-body]');
    const toc = document.querySelector('[data-hub-toc]');
    if (!body || !toc) return;

    const heads = Array.from(body.querySelectorAll('h2'));
    if (heads.length < 4) return;

    const list = toc.querySelector('.hub-toc__list');
    const used = {};
    heads.forEach((h) => {
      let id = (h.textContent || '')
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 60);
      if (!id) return;
      if (used[id]) { used[id] += 1; id = id + '-' + used[id]; } else { used[id] = 1; }
      h.id = id;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    if (list.children.length) toc.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scope = document.querySelector('.main-product');
    if (!scope) return;

    const mainImage = scope.querySelector('.main-product__main-image');
    const thumbs = Array.from(scope.querySelectorAll('[data-main-thumb]'));
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage && thumb.dataset.src) {
          mainImage.srcset = '';
          mainImage.src = thumb.dataset.src;
        }
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const form = document.getElementById('MainProductForm');
    if (!form) return;

    const variantSelect = form.querySelector('[data-main-variant-select]');
    const price = scope.querySelector('[data-main-price]');
    const compare = scope.querySelector('[data-main-compare]');
    const submit = form.querySelector('[data-main-submit]');
    const stickyPrice = document.querySelector('[data-main-sticky-price]');
    const stickySubmit = document.querySelector('[data-main-sticky-submit]');

    const variants = variantSelect ? Array.from(variantSelect.options).map((option) => ({
      id: option.value,
      price: option.dataset.price || '',
      compare: option.dataset.compare || '',
      available: option.dataset.available === 'true',
      mediaId: option.dataset.mediaId || '',
      options: [option.dataset.option1 || '', option.dataset.option2 || '', option.dataset.option3 || ''],
    })) : [];

    const syncVariantMedia = (mediaId) => {
      if (!mediaId) return;
      const matchingThumb = thumbs.find((thumb) => thumb.dataset.mediaId === mediaId);
      if (!matchingThumb) return;
      matchingThumb.click();
    };

    const getSelectedValues = () => [1, 2, 3].map((position) => {
      const checked = form.querySelector(`fieldset[data-option-position="${position}"] input:checked`);
      return checked ? checked.value : '';
    });

    const setSelectedValues = (values) => {
      values.forEach((value, index) => {
        if (!value) return;
        const input = form.querySelector(`fieldset[data-option-position="${index + 1}"] input[value="${CSS.escape(value)}"]`);
        if (input && !input.disabled) input.checked = true;
      });
    };

    const updateAvailability = (selectedValues) => {
      [1, 2, 3].forEach((position) => {
        const fieldset = form.querySelector(`fieldset[data-option-position="${position}"]`);
        if (!fieldset) return;
        const inputs = Array.from(fieldset.querySelectorAll('input'));
        inputs.forEach((input) => {
          const nextValues = [...selectedValues];
          nextValues[position - 1] = input.value;
          const hasAvailableVariant = variants.some((variant) => variant.available && variant.options.every((variantValue, index) => !nextValues[index] || variantValue === nextValues[index]));
          input.disabled = !hasAvailableVariant;
          input.nextElementSibling?.classList.toggle('is-disabled', !hasAvailableVariant);
        });
      });
    };

    const syncVariant = () => {
      if (!variantSelect) return;
      let selectedValues = getSelectedValues();
      updateAvailability(selectedValues);

      let matched = variants.find((variant) => variant.options.every((value, index) => !selectedValues[index] || selectedValues[index] === value));
      if (!matched) {
        matched = variants.find((variant) => variant.available && variant.options.every((value, index) => !selectedValues[index] || selectedValues[index] === value)) || variants.find((variant) => variant.available) || variants[0];
        if (matched) {
          setSelectedValues(matched.options);
          selectedValues = matched.options;
          updateAvailability(selectedValues);
        }
      }

      if (!matched) return;

      variantSelect.value = matched.id;
      const available = matched.available;

      if (price) price.textContent = matched.price || price.textContent;

      if (compare) {
        if (matched.compare) {
          compare.hidden = false;
          compare.textContent = matched.compare;
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? (submit.dataset.labelAdd || submit.textContent) : (submit.dataset.labelSold || submit.textContent);
      }

      if (stickyPrice) stickyPrice.textContent = matched.price || stickyPrice.textContent;
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? (stickySubmit.dataset.labelAdd || stickySubmit.textContent) : (stickySubmit.dataset.labelSold || stickySubmit.textContent);
      }

      syncVariantMedia(matched.mediaId);
    };

    form.querySelectorAll('fieldset input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', syncVariant);
    });

    const qtyInput = form.querySelector('[data-main-qty-input]');
    form.querySelectorAll('[data-main-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!qtyInput) return;
        const current = Number(qtyInput.value) || 1;
        const next = button.dataset.mainQty === 'up' ? current + 1 : Math.max(1, current - 1);
        qtyInput.value = String(next);
      });
    });

    if (stickySubmit) {
      stickySubmit.addEventListener('click', () => {
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.click();
      });
    }

    syncVariant();

    // ?? Selling plan / subscription support ??
    const purchaseOptions = scope.querySelector('[data-purchase-options]');
    const sellingPlanInput = form ? form.querySelector('[data-selling-plan-input]') : null;
    const planDataEl = scope.querySelector('[data-selling-plan-allocations]');

    if (purchaseOptions && planDataEl) {
      let planData = { allocations: [], groupPlans: {} };
      try { planData = JSON.parse(planDataEl.textContent); } catch (e) {}

      const planRadios = Array.from(purchaseOptions.querySelectorAll('[data-plan-radio]'));

      const setActivePlan = (radio) => {
        const type = radio.dataset.planType;
        const groupId = radio.dataset.groupId || '';
        purchaseOptions.querySelectorAll('[data-plan-frequency]').forEach((el) => { el.hidden = true; });

        if (type === 'otp' || !groupId) {
          if (sellingPlanInput) { sellingPlanInput.value = ''; sellingPlanInput.disabled = true; }
        } else {
          const freqEl = purchaseOptions.querySelector('[data-plan-frequency="' + groupId + '"]');
          if (freqEl) freqEl.hidden = false;
          if (sellingPlanInput) {
            const freqSelect = freqEl ? freqEl.querySelector('[data-plan-freq-select]') : null;
            const singleInput = freqEl ? freqEl.querySelector('[data-plan-freq-single]') : null;
            const planId = freqSelect ? freqSelect.value : (singleInput ? singleInput.value : '');
            sellingPlanInput.value = planId;
            sellingPlanInput.disabled = !planId;
          }
        }
      };

      const syncPlanPrices = () => {
        const variantId = variantSelect ? String(variantSelect.value) : null;
        if (!variantId) return;
        const variantAllocs = planData.allocations.filter((a) => String(a.variantId) === variantId);

        // Update OTP price card to match main price display
        const otpPriceEl = purchaseOptions.querySelector('[data-otp-price]');
        const mainPriceEl = scope.querySelector('[data-main-price]');
        if (otpPriceEl && mainPriceEl) otpPriceEl.textContent = mainPriceEl.textContent;

        // Update each group's subscription price card
        Object.entries(planData.groupPlans || {}).forEach(([groupId, planIds]) => {
          const alloc = variantAllocs.find((a) => planIds.map(String).includes(String(a.planId)));
          if (!alloc) return;
          const subPriceEl = purchaseOptions.querySelector('[data-sub-price="' + groupId + '"]');
          const wasPriceEl = purchaseOptions.querySelector('[data-was-price="' + groupId + '"]');
          if (subPriceEl) subPriceEl.textContent = alloc.priceMoney;
          if (wasPriceEl) wasPriceEl.textContent = alloc.compareMoney;
        });

        // Re-sync selling_plan input if sub is still selected
        const checkedRadio = purchaseOptions.querySelector('[data-plan-radio]:checked');
        if (checkedRadio) setActivePlan(checkedRadio);
      };

      planRadios.forEach((radio) => {
        radio.addEventListener('change', () => setActivePlan(radio));
      });

      purchaseOptions.querySelectorAll('[data-plan-freq-select]').forEach((select) => {
        select.addEventListener('change', () => {
          if (sellingPlanInput) {
            sellingPlanInput.value = select.value;
            sellingPlanInput.disabled = !select.value;
          }
        });
      });

      // Update plan prices whenever variant changes
      form && form.querySelectorAll('fieldset input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => setTimeout(syncPlanPrices, 0));
      });

      // Initialise
      const initRadio = purchaseOptions.querySelector('[data-plan-radio]:checked');
      if (initRadio) setActivePlan(initRadio);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
